export default "__VITE_ASSET__BEIxzQC3__";